import { createSlice } from '@reduxjs/toolkit';

const languageSlice = createSlice({
  name: 'language',
  initialState: { language: 'en', labels: {}},
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setLabels: (state, action) => {
      state.labels = action.payload
    }
  },
});

export const { setLanguage, setLabels} = languageSlice.actions;
export default languageSlice.reducer;
